import PaginationContainer from './PaginationContainer';

export default PaginationContainer;
